// Firebase configuration and Analytics initialization
// Docs: https://firebase.google.com/docs/analytics/get-started?platform=web
import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, logEvent, isSupported, setAnalyticsCollectionEnabled } from 'firebase/analytics';

export const GA_MEASUREMENT_ID = 'G-Y86DZHG9QJ';

const firebaseConfig = {
  apiKey: 'AIzaSyDoNj6OXYanWAIwsEjux3-YjGACqDkrhOg',
  authDomain: 'naijanest-13c0d.firebaseapp.com',
  projectId: 'naijanest-13c0d',
  storageBucket: 'naijanest-13c0d.firebasestorage.app',
  messagingSenderId: '81537355138',
  appId: '1:81537355138:web:8cf03ce0da535f7a0e539b',
  measurementId: GA_MEASUREMENT_ID,
};

// Analytics is never initialised at import time: it only starts collecting
// once the visitor consents to the "Analytics" cookie category (see
// CookieConsentContext), so no analytics cookies are set before that.
let analytics = null;

/**
 * Start Firebase Analytics collection. Safe to call more than once, a
 * second call just re-enables collection if it was previously disabled.
 */
export const initAnalytics = () => {
  if (typeof window === 'undefined' || !firebaseConfig.measurementId) {
    return;
  }
  if (analytics) {
    setAnalyticsCollectionEnabled(analytics, true);
    return;
  }
  const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
  // isSupported() returns false in some environments (e.g. SSR, some privacy browsers)
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
};

/** Stop Firebase Analytics collection without a page reload. */
export const disableAnalytics = () => {
  if (analytics) {
    setAnalyticsCollectionEnabled(analytics, false);
  }
};

/**
 * Log a page-view event.
 * Call this on every route change. No-ops until initAnalytics() has run.
 */
export const logPageView = (path, title) => {
  if (analytics) {
    logEvent(analytics, 'page_view', {
      page_path: path,
      page_title: title || document.title,
    });
  }
};

export { analytics };
